import { Fragment } from 'react';

const LEADING_BRACKET_PREFIX = /^(\[[^\]]+\])(.*)$/;

interface InternalNoteFormattedTextProps {
  text: string;
  className?: string;
}

export const InternalNoteFormattedText = ({ text, className }: InternalNoteFormattedTextProps) => {
  const lines = text.split('\n');

  return (
    <p className={className ? `whitespace-pre-wrap ${className}` : 'whitespace-pre-wrap'}>
      {lines.map((line, i) => {
        const match = line.match(LEADING_BRACKET_PREFIX);
        const node = match ? (
          <>
            <span className="text-black">{match[1]}</span>
            <span className="text-gray-500">{match[2]}</span>
          </>
        ) : (
          <span className="text-gray-500">{line}</span>
        );
        return (
          <Fragment key={i}>
            {i > 0 ? <br /> : null}
            {node}
          </Fragment>
        );
      })}
    </p>
  );
};
